/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect } from 'react'
import { Table } from 'react-bootstrap-v5';
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { Editor } from '@tinymce/tinymce-react';
import { Link } from 'react-router-dom';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { useHistory, useLocation } from "react-router-dom";

interface QuotationRows {
    idProducts: number;
    idProductGroupAlternateNames: number;
    quantity: number;
    rate: number;
    transportation_cost: number;
    effective_rate: number;
    weight_in_kg: number;
    discount: number;
    srDiscount: number;
    adminDiscount: number;
    maxDiscount: number;
    amount: number;
    originalRate: number;
    remarks: string;
    delivery_location: string;
    [key: string]: any;
}

interface QuotationTerms {
    clause: string;
    [key: string]: any;
}

interface Product {
    id_products: number;
    product_name: string;
}

interface QuotationData {
    idProjects: number;
    idLeads: number;
    date: string;
    referenceNo: string;
    quotationBody: string;
    quotationFooter: string;
}


const SalesQuotationCreate = () => {

    let history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const idSalesQuotations = queryParams.get('idSalesQuotations');
    const isEditMode = !!idSalesQuotations;

    const initTextPre = ''
    const [initTextFooter, setInitTextFooter] = useState('');
    const [editorBodyKey, setEditorBodyKey] = useState(0);
    const [editorFooterKey, setEditorFooterKey] = useState(0);
    const [loadingQuotation, setLoadingQuotation] = useState(isEditMode);

    const getUserInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'users/get_user_info',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {


            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const [initText, setInitText] = useState(initTextPre);

    const quotationData: QuotationData = {
        idProjects: 0,
        idLeads: 0,
        date: '',
        referenceNo: '',
        quotationBody: initText,
        quotationFooter: initTextFooter
    };

    const handleQuotationBodyChange = (content: any) => {
        setQuotation({ ...quotation, quotationBody: content });
    }

    const handleQuotationFooterChange = (content: any) => {
        setQuotation({ ...quotation, quotationFooter: content });
    }

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [leads, setLeads] = useState([]);
    const [quotation, setQuotation] = useState(quotationData);
    const [lead, setLead] = useState({ label: 'Select Lead', value: '' });
    const [products, setProducts] = useState<Product[]>([]);
    const [showTransportationCost, setShowTransportationCost] = useState(true);
    const [showEffectiveRate, setShowEffectiveRate] = useState(true);
    const [showSrMaxDiscount, setShowSrMaxDiscount] = useState(true);
    const [showAdminMaxDiscount, setShowAdminMaxDiscount] = useState(true);
    const [showWeight, setShowWeight] = useState(false);

    const applyProjectFieldVisibility = (selectedProject: any) => {
        setShowTransportationCost(selectedProject?.showTransportationCost !== 'No');
        setShowEffectiveRate(selectedProject?.showEffectiveRate !== 'No');
        setShowSrMaxDiscount(selectedProject?.showSrMaxDiscount !== 'No');
        setShowAdminMaxDiscount(selectedProject?.showAdminMaxDiscount !== 'No');
        setShowWeight(selectedProject?.showWeight === 'Yes');
    }

    useEffect(() => {
        getProjects();
        getUserInfo();
    }, [])

    useEffect(() => {
        if (isEditMode && idSalesQuotations) {
            loadQuotationDetails(idSalesQuotations);
        }
    }, [isEditMode, idSalesQuotations]);

    const loadQuotationDetails = async (quotationId: string) => {
        setLoadingQuotation(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}quotation/${quotationId}`,
                getRequestOptions()
            );
            const respData = await response.json();
            const quotationData = respData.quotation;

            if (!quotationData) {
                throw new Error('Quotation not found');
            }

            const quotationDate = quotationData.quotation_date
                ? String(quotationData.quotation_date).substring(0, 10)
                : '';

            setQuotation({
                idProjects: quotationData.id_projects,
                idLeads: quotationData.id_leads,
                date: quotationDate,
                referenceNo: quotationData.reference_number ?? '',
                quotationBody: quotationData.quotation_text ?? '',
                quotationFooter: quotationData.quotation_footer ?? '',
            });

            setProject({
                label: quotationData.project?.project_name ?? 'Select Project',
                value: quotationData.id_projects,
            });

            setLead({
                label: quotationData.lead?.lead_name ?? 'Select Lead',
                value: quotationData.id_leads,
            });

            setInitText(quotationData.quotation_text ?? '');
            setInitTextFooter(quotationData.quotation_footer ?? '');
            setEditorBodyKey((prev) => prev + 1);
            setEditorFooterKey((prev) => prev + 1);

            const mappedRows = (quotationData.rows ?? []).map((row: any) => {
                const rate = parseFloat(row.unit_rate) || 0;
                const transportationCost = parseFloat(row.transportation_cost) || 0;
                const quantity = parseFloat(row.quantity) || 0;
                const originalRate = parseFloat(row.original_rate) || rate;

                return {
                    idProducts: row.id_products,
                    idProductGroupAlternateNames: row.id_product_group_alternate_names,
                    quantity,
                    rate,
                    transportation_cost: transportationCost,
                    effective_rate: rate + transportationCost,
                    discount: parseFloat(row.discount_percent) || 0,
                    amount: parseFloat((quantity * (rate + transportationCost)).toFixed(2)),
                    originalRate,
                    remarks: row.remarks ?? '',
                    delivery_location: row.delivery_location ?? '',
                };
            });

            setQuotationRows(mappedRows.length > 0 ? mappedRows : [{
                idProducts: 0,
                idProductGroupAlternateNames: 0,
                quantity: 0,
                rate: 0,
                transportation_cost: 0,
                effective_rate: 0,
                discount: 0,
                amount: 0,
                originalRate: 0,
                remarks: '',
                delivery_location: '',
            }]);

            const mappedTerms = (quotationData.terms ?? []).map((term: any) => ({
                clause: term.clause ?? term.terms_clause ?? '',
            }));

            setQuotationTerms(mappedTerms.length > 0 ? mappedTerms : [{ clause: '' }]);

            await getProjectLeads(quotationData.id_projects);
            await getProducts(quotationData.id_projects);
        } catch (error) {
            console.log(error, 'catch the hoop');
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to load quotation details',
            });
        } finally {
            setLoadingQuotation(false);
        }
    };

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getProjectLeads = async (idProjects: number) => {

        const response = await fetch(
            process.env.REACT_APP_API_URL + 'getLeadsByProject/' + idProjects,
            getRequestOptions()
        );
        const resp = await response.json();
        let leadObj = resp.data.map((item: any) => {
            item.label = item.lead_name;
            item.value = item.id_leads;
            return item
        })
        setLeads(leadObj);
    }

    const getInitText = (idLeads: number) => {

        fetch(
            process.env.REACT_APP_API_URL + 'quotationInitText/' + idLeads,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                console.log(resp);
                setInitText(resp.text)
                setInitTextFooter(resp.textFooter)
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        applyProjectFieldVisibility(project);
        getProjectLeads(project.value);
        setQuotation({ ...quotation, idProjects: project.value });
        getProducts(project.value);
        setQuotationRows([{
            idProducts: 0,
            idProductGroupAlternateNames: 0,
            quantity: 0,
            rate: 0,
            transportation_cost: 0,
            effective_rate: 0,
            weight_in_kg: 0,
            discount: 0,
            srDiscount: 0,
            adminDiscount: 0,
            maxDiscount: 0,
            amount: 0,
            originalRate: 0,
            remarks: '',
            delivery_location: '',
        }]);
    }

    const handleLeadChange = (lead: any) => {
        setLead(lead);
        setQuotation({ ...quotation, idLeads: lead.value });
        if (!isEditMode) {
            getInitText(lead.value);
        }
    }

    const handleItemChange = (data: any, index: number) => {
        const updatedQuotationRows = [...quotationRows];
        updatedQuotationRows[index].idProducts = data.value.split('-')[0];
        updatedQuotationRows[index].idProductGroupAlternateNames = data.value.split('-')[1] === "null" ? null : data.value.split('-')[1];
        updatedQuotationRows[index].originalRate = parseFloat(data.sale_per_unit);
        updatedQuotationRows[index].effective_rate = parseFloat(data.sale_per_unit);
        updatedQuotationRows[index].rate = parseFloat(data.sale_per_unit);
        updatedQuotationRows[index].srDiscount = parseFloat(data.discount_percent_sr) || 0;
        updatedQuotationRows[index].adminDiscount = parseFloat(data.discount_percent_admin) || 0;
        updatedQuotationRows[index].maxDiscount = parseFloat(data.max_discount) || 0;
        updatedQuotationRows[index].weight_in_kg = parseFloat(data.weight_in_kg) || 0;
        setQuotationRows(updatedQuotationRows);
    }

    const getProducts = async (project: number) => {

        const response = await fetch(
            process.env.REACT_APP_API_URL + 'products?idProjects=' + project,
            getRequestOptions()
        );
        const resp = await response.json();

        let products = resp.data.map((item: any) => {
            const packingLabel = item.name_value + ' (' + item.packing + ' ' + item.item_unit_name + ')';
            item.label = item.product_code ? item.product_code + ' - ' + packingLabel : packingLabel;
            item.value = item.id_products + '-' + item.id_product_group_alternate_names;
            item.unitRate = item.sale_per_unit;
            return item
        })
        setProducts(products);
    }

    const getProductSelectValue = (row: QuotationRows) => {
        if (!row.idProducts) {
            return null;
        }

        const alternateId = row.idProductGroupAlternateNames ?? 'null';
        return products.find((product: any) => product.value === `${row.idProducts}-${alternateId}`) ?? null;
    }


    // const [isSubmitDisable, setSubmitDisable] = useState(false);
    // const [loading, setLoading] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedQuotationRows = [...quotationRows];
        const fieldName = e.target.name;
        updatedQuotationRows[index][fieldName] = (e.target.type === 'number') ? parseFloat(e.target.value) || 0 : e.target.value;

        if (fieldName === 'discount') {
            updatedQuotationRows[index].rate = updatedQuotationRows[index].originalRate - (updatedQuotationRows[index].discount * updatedQuotationRows[index].originalRate / 100);
        }

        updatedQuotationRows[index].effective_rate = updatedQuotationRows[index].rate + updatedQuotationRows[index].transportation_cost;
        updatedQuotationRows[index].amount = parseFloat((updatedQuotationRows[index].quantity * (updatedQuotationRows[index].rate + updatedQuotationRows[index].transportation_cost)).toFixed())
        setQuotationRows(updatedQuotationRows);
    }

    const handleTermChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedQuotationTerms = [...quotationTerms];
        updatedQuotationTerms[index][e.target.name] = e.target.value;
        setQuotationTerms(updatedQuotationTerms);
    }

    const deleteProduct = (index: number) => {
        const updatedQuotationRows = [...quotationRows];
        if (updatedQuotationRows && updatedQuotationRows[index]) {
            updatedQuotationRows.splice(index, 1);
            setQuotationRows(updatedQuotationRows);
        }
    }

    const deleteTerm = (index: number) => {
        const updatedQuotationTerms = [...quotationTerms];
        if (updatedQuotationTerms && updatedQuotationTerms[index]) {
            updatedQuotationTerms.splice(index, 1);
            setQuotationTerms(updatedQuotationTerms);
        }
    }

    const quotationSave = async (event: any) => {
        event.preventDefault()
        // setSubmitDisable(true);
        // setLoading(true);
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: isEditMode ? 'You want to update this Quotation?' : 'You want to create this Quotation?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: isEditMode ? 'Yes, Update it!' : 'Yes, Create it!',
        })
        if (confirm.value) {
            const sanitizedRows = quotationRows.map((row) => ({
                ...row,
                transportation_cost: showTransportationCost ? (row.transportation_cost || 0) : 0,
                weight_in_kg: showWeight ? (parseFloat(String(row.weight_in_kg)) || 0) : null,
            }));
            const postData = {
                ...(isEditMode ? { idSalesQuotations: idSalesQuotations } : {}),
                quotation: quotation,
                quotationRows: sanitizedRows,
                quotationTerms: quotationTerms,
            }
            const requestOptions = postRequestOptions(postData)
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}quotation${isEditMode ? '/update' : ''}`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage ?? respData.errorMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })

                    history.push("/sales-quotations");
                } else {
                    const errorsMessage = respData.errors
                        ? validationErrorMsg(respData.errors).join('<br>')
                        : (respData.errorMessage ?? 'Request failed');
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    })
                }
                // setSubmitDisable(false);
                // setLoading(false);
            } catch (error) {
                console.log(error, 'catch the hoop')
                // setSubmitDisable(false);
                // setLoading(false);
            }
        }
    }

    const addProduct = (index: number) => {
        const newRow: QuotationRows = {
            idProducts: 0,
            idProductGroupAlternateNames: 0,
            quantity: 0,
            rate: 0,
            transportation_cost: 0,
            effective_rate: 0,
            weight_in_kg: 0,
            discount: 0,
            srDiscount: 0,
            adminDiscount: 0,
            maxDiscount: 0,
            amount: 0,
            originalRate: 0,
            remarks: '',
            delivery_location: '',
        };

        const updatedRows = [...quotationRows];
        updatedRows.push(newRow);

        setQuotationRows(updatedRows);
    }

    const addTerm = (index: number) => {
        const newTerm: QuotationTerms = {
            clause: '',
        };

        const updatedTerms = [...quotationTerms];
        updatedTerms.push(newTerm);
        setQuotationTerms(updatedTerms);
    }

    const handleInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setQuotation({ ...quotation, [event.target.name]: event.target.value });
    }

    const editorConfig = {
        height: 500,
        menubar: false,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount',
            'textalignjustify',
        ],
        toolbar:
            'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help'
    };

    const [quotationRows, setQuotationRows] = useState<QuotationRows[]>([{
        idProducts: 0,
        idProductGroupAlternateNames: 0,
        quantity: 0,
        rate: 0,
        transportation_cost: 0,
        effective_rate: 0,
        weight_in_kg: 0,
        discount: 0,
        srDiscount: 0,
        adminDiscount: 0,
        maxDiscount: 0,
        amount: 0,
        originalRate: 0,
        remarks: '',
        delivery_location: '',
    }]);

    const [quotationTerms, setQuotationTerms] = useState<QuotationTerms[]>([{
        clause: '',
    }]);

    return (

        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/svg/icons/Home/Book-open.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        {isEditMode ? 'Edit Sales Quotation' : 'Create Sales Quotation'}
                    </span>
                </div>
            </div>

            <div className="ml-12">
                <div className="card-body">
                    {/* {<pre>{JSON.stringify(quotationRows, null, 2)}</pre>} */}
                    {loadingQuotation ? (
                        <div className="text-center py-10">Loading quotation...</div>
                    ) : (
                    <form onSubmit={quotationSave}>
                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idLeads" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Leads <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={lead}
                                    onChange={handleLeadChange}
                                    options={leads}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="date" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Date  <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input type='date' name="date" id="date" value={quotation.date} onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>
                        {isEditMode && (
                            <div className="form-group row mb-2">
                                <label htmlFor="referenceNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Reference No</label>
                                <div className="col-lg-5">
                                    <input name="referenceNo" id="referenceNo" value={quotation.referenceNo} readOnly className="form-control form-control-sm" />
                                </div>
                            </div>
                        )}
                        {/* <div className="form-group row mb-2">
                            <label htmlFor="referenceNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Reference No  <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input name="referenceNo" id="referenceNo" onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div> */}
                        <div className="form-group row mb-2">
                            <label htmlFor="quotationBody" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Quotation Header  <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Editor
                                    key={`quotation-body-${editorBodyKey}`}
                                    apiKey="c86hkmb8gwenrnbdfmj540pulih521ihze9v44lv1sf9a80h"
                                    initialValue={initText}
                                    init={editorConfig}
                                    onEditorChange={handleQuotationBodyChange}
                                />
                            </div>
                        </div>

                        <br></br>
                        <div className="table-responsive">
                        <Table size='sm' bordered hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }} className='text-center'>SL</th>
                                    <th style={{ width: '16%' }} className='text-center'>Product Name <span className="text-danger">*</span></th>
                                    <th style={{ width: '8%' }} className='text-center'>Delivery Location</th>
                                    {showWeight && <th style={{ width: '7%' }} className='text-center'>Weight (KG)</th>}
                                    <th style={{ width: '8%' }} className='text-center'>Rate (Per Unit)</th>
                                    {showTransportationCost && <th style={{ width: '8%' }} className='text-center'>Transportation Cost (Per Unit)</th>}
                                    {showEffectiveRate && <th style={{ width: '8%' }} className='text-center'>Effective Rate (Rate + Transportation Cost)</th>}
                                    <th style={{ width: '8%' }} className='text-center'>Quantity</th>
                                    <th style={{ width: '8%' }} className='text-center'>Amount</th>
                                    {showSrMaxDiscount && <th style={{ width: '7%' }} className='text-center'>SR Max Discount (%)</th>}
                                    {showAdminMaxDiscount && <th style={{ width: '7%' }} className='text-center'>Admin Max Discount (%)</th>}
                                    <th style={{ width: '8%' }} className='text-center'>Discount (%)</th>
                                    <th style={{ width: '8%' }} className='text-center'>Remarks</th>
                                    <th style={{ width: '15%' }}></th>
                                </tr>
                            </thead>


                            <tbody>

                                {quotationRows.map((row, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td>
                                            <Select
                                                value={getProductSelectValue(row)}
                                                onChange={(selectedOption) => handleItemChange(selectedOption, index)}
                                                options={products}
                                                className='sm'
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                        minHeight: '32px',
                                                    }),
                                                    container: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                    }),
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <input type="text" name="delivery_location" value={row.delivery_location} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        {showWeight && (
                                            <td>
                                                <input
                                                    type="number"
                                                    name="weight_in_kg"
                                                    step="0.001"
                                                    value={row.weight_in_kg ?? 0}
                                                    onChange={(event) => handleChange(event, index)}
                                                    className="form-control form-control-sm"
                                                />
                                            </td>
                                        )}
                                        <td>
                                            <input type="number" name="rate" value={row.rate} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        {showTransportationCost && (
                                            <td>
                                                <input type="number" name="transportation_cost" value={row.transportation_cost} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                            </td>
                                        )}
                                        {showEffectiveRate && (
                                            <td>
                                                <input type="number" name="effective_rate" readOnly value={row.effective_rate} className="form-control form-control-sm" />
                                            </td>
                                        )}
                                        <td>
                                            <input type="number" name="quantity" value={row.quantity || ''} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <input type="number" name="amount" readOnly value={row.amount} className="form-control form-control-sm" />
                                        </td>
                                        {showSrMaxDiscount && (
                                            <td>
                                                <input type="number" name="srDiscount" value={row.srDiscount || 0} className="form-control form-control-sm" readOnly />
                                            </td>
                                        )}
                                        {showAdminMaxDiscount && (
                                            <td>
                                                <input type="number" name="adminDiscount" value={row.adminDiscount || 0} className="form-control form-control-sm" readOnly />
                                            </td>
                                        )}
                                        <td>
                                            <input type="number" name="discount" value={row.discount || ''} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <input type="text" name="remarks" value={row.remarks} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteProduct(index)}>
                                                <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                            </button>
                                            {index === quotationRows.length - 1 && (
                                                <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addProduct(index)}>
                                                    <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add More Product
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}

                            </tbody>



                        </Table>
                        </div>
                        <br></br>
                        <h4>Business Terms & Conditions:</h4>
                        <Table size='sm' bordered hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }} className='text-center'>SL</th>
                                    <th style={{ width: '75%' }}>Clause</th>
                                    <th style={{ width: '20%' }}></th>
                                </tr>
                            </thead>

                            <tbody>

                                {quotationTerms.map((row, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td>
                                            <input type="text" name="clause" value={row.clause} onChange={(event) => handleTermChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteTerm(index)}>
                                                <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                            </button>
                                            {index === quotationTerms.length - 1 && (
                                                <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addTerm(index)}>
                                                    <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add More Term
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}

                            </tbody>



                        </Table>

                        <div className="form-group row mb-2">
                            <label htmlFor="quotationBody" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Quotation Footer  <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Editor
                                    key={`quotation-footer-${editorFooterKey}`}
                                    apiKey="c86hkmb8gwenrnbdfmj540pulih521ihze9v44lv1sf9a80h"
                                    initialValue={initTextFooter}
                                    init={editorConfig}
                                    onEditorChange={handleQuotationFooterChange}
                                />
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <input type="submit" className="btn btn-sm btn-success me-2" value={isEditMode ? 'Update Quotation' : 'Create Quotation'} />
                                <Link to='/sales-quotations' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                            </div>
                        </div>

                    </form>
                    )}

                </div>
            </div>
        </div>

    )
}

export default SalesQuotationCreate
